import { InputAdornment } from "@mui/material";
import Iconify from "../Iconify";

export const getVoiceSearchLanguages = (t: any) => [
  {
    code: "en-US",
    label: t("English"),
    icon: "/assets/icons/ic_flag_en.svg",
  },
  {
    code: "ta-IN",
    label: t("Tamil"),
    icon: "/assets/icons/ic_flag_ta.svg",
  },
  {
    code: "te-IN",
    label: t("Telugu"),
    icon: "/assets/icons/ic_flag_te.svg",
  },
  {
    code: "ml-IN",
    label: t("Malayalam"),
    icon: "/assets/icons/ic_flag_ml.svg",
  },
  {
    code: "kn-IN",
    label: t("Kannada"),
    icon: "/assets/icons/ic_flag_kn.svg",
  },
  {
    code: "hi-IN",
    label: t("Hindi"),
    icon: "/assets/icons/ic_flag_hi.svg",
  },
  {
    code: "bn-IN",
    label: t("Bengali"),
    icon: "/assets/icons/ic_flag_bn.svg",
  },
  {
    code: "pa-IN",
    label: t("Punjabi"),
    icon: "/assets/icons/ic_flag_pa.svg",
  },
  {
    code: "mr-IN",
    label: t("Marathi"),
    icon: "/assets/icons/ic_flag_mr.svg",
  },
  {
    code: "gu-IN",
    label: t("Gujarati"),
    icon: "/assets/icons/ic_flag_gu.svg",
  },
  { code: "ur-PK", label: t("Urdu"), icon: "/assets/icons/ic_flag_ur.svg" },
  {
    code: "zh-CN",
    label: t("Chinese"),
    icon: "/assets/icons/ic_flag_zh.svg",
  },
  {
    code: "es-ES",
    label: t("Spanish"),
    icon: "/assets/icons/ic_flag_es.svg",
  },
  {
    code: "fr-FR",
    label: t("French"),
    icon: "/assets/icons/ic_flag_fr.svg",
  },
  {
    code: "ja-JP",
    label: t("Japanese"),
    icon: "/assets/icons/ic_flag_ja.svg",
  },
  {
    code: "ru-RU",
    label: t("Russian"),
    icon: "/assets/icons/ic_flag_ru.svg",
  },
  {
    code: "de-DE",
    label: t("German"),
    icon: "/assets/icons/ic_flag_de.svg",
  },
  {
    code: "it-IT",
    label: t("Italian"),
    icon: "/assets/icons/ic_flag_it.svg",
  },
  {
    code: "ko-KR",
    label: t("Korean"),
    icon: "/assets/icons/ic_flag_ko.svg",
  },
  {
    code: "ar-SA",
    label: t("Arabic"),
    icon: "/assets/icons/ic_flag_ar.svg",
  },
];

export const getVSLanguageCode = (t: any, baseCode: string) => {
  let result = getVoiceSearchLanguages(t).find(
    (l) => l.code.indexOf(`${baseCode}-`) === 0
  )?.code;
  if (result) {
    return result;
  } else {
    return "en-US";
  }
};

export const getRecognition = () => {
  return (
    (window as any).SpeechRecognition ||
    (window as any).webkitSpeechRecognition ||
    (window as any).mozSpeechRecognition ||
    (window as any).msSpeechRecognition ||
    (window as any).oSpeechRecognition ||
    null
  );
};

export const isOpera = () => {
  if (
    navigator.userAgent.includes("OPR") ||
    navigator.userAgent.includes("Opera")
  ) {
    return true;
  }
  // chromium brand check also needed
  // @ts-ignore experimental
  return navigator?.userAgentData?.brands?.some((b: any) =>
    b.brand.includes("Opera")
  );
};

export const isSupported =
  getRecognition() &&
  !navigator.userAgent.includes("Firefox") &&
  !navigator.userAgent.includes("OPR") &&
  !navigator.userAgent.includes("Opera");

export const micIcon = (
  handler: any,
  handleClick: any,
  isActive?: boolean,
  onStop?: () => void,
  rippleScale?: any
) =>
  isActive ? (
    <div
      onClick={onStop}
      style={{
        position: "relative",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <span
        className="volume-ripple"
        style={{
          transform: `translate(-50%, -50%) scale(${rippleScale})`,
        }}
      />
      <span
        className="volume-ripple"
        style={{
          transform: `translate(-50%, -50%) scale(${rippleScale * 0.85})`,
        }}
      />
      <span
        className="volume-ripple"
        style={{
          transform: `translate(-50%, -50%) scale(${rippleScale * 0.7})`,
        }}
      />
      <Iconify
        icon="ic:round-mic"
        width={24}
        height={24}
        style={{ cursor: "pointer", color: "#f50057" }}
      />
    </div>
  ) : (
    <div
      {...(handler ? { onMouseDown: handler } : { onClick: handleClick })}
      style={{
        display: "flex",
        cursor: "pointer",
        alignItems: "center",
      }}
    >
      <Iconify
        icon="ic:round-mic"
        width={24}
        height={24}
        style={{
          pointerEvents: "none",
        }}
        // className="mic-icon"
      />
    </div>
  );

export const micAdornment = (
  handler: any,
  handleClick: any,
  isActive?: boolean,
  onStop?: () => void,
  rippleScale?: any
) =>
  isSupported ? (
    <InputAdornment position="end" className={isActive ? "" : "mic-icon"}>
      {micIcon(handler, handleClick, isActive, onStop, rippleScale)}
    </InputAdornment>
  ) : null;
